import { RegionsEnum } from "redlineLibsServerSafe"
import { LngLat } from "./content.model"

/**
 * defining Region as a type enforces that all of the regions from RegionEnum are defined in regionData
 */
export type Region = {
  audioTour: boolean
  firewall: boolean
  titleRedlining: string
  titleStories: string
  enabled?: boolean
  label: string
  region: RegionsEnum
  redliningRegion: RegionsEnum
  location: LngLat
  geoJson: string
  zoom?: number
}

export type RegionsData = {
  [key in keyof typeof RegionsEnum]: Region
}
